import { useMutation } from "@tanstack/react-query";
import { refreshToken } from "../../lib/services/authService";
import type { AuthTokens } from "../../lib/auth/AuthRegistry";

/**
 * useRefreshToken: React Query mutation hook for refreshing tokens.
 * Usage: const { mutate: refresh, isLoading, error, data } = useRefreshToken();
 */
export function useRefreshToken() {
  return useMutation<AuthTokens, Error, string>({
    mutationKey: ["auth", "refreshToken"],
    mutationFn: refreshToken,
  });
}
